var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-site"},[_c('div',{staticClass:"g-site-content"},[_c('i',{staticClass:"icon iconfont icon-index"}),_c('span',{on:{"click":function($event){return _vm.linkTo()}}},[_vm._v(" 您当前位置："+_vm._s(_vm.site))])])])}
var staticRenderFns = []

export { render, staticRenderFns }